import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import { IItemBase } from '@shared/interfaces/IItemBase';
import { IListItem } from '@shared/interfaces/IListItem';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { FilterService } from '@shared/services/filter.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-paginator',
    templateUrl: './paginator.component.html',
    styleUrls: ['./paginator.component.scss'],
    standalone: false
})
export class PaginatorComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() pageSize: number;
    @Input() pageSizeOptions: number[] = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
    @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
    @Output() changed = new EventEmitter();

    currentEvent: PageEvent;
    listItem: IListItem = { count: 0, results: [] };
    subscription: Subscription;

    constructor(
        public filterService: FilterService,
        public changeDetection: ChangeDetectorRef
    ) {}

    get items(): IItemBase[] {
        return this.filteredItems.slice(
            this.paginator ? this.paginator.pageIndex * this.paginator.pageSize : 0,
            this.paginator
                ? this.paginator.pageIndex * this.paginator.pageSize + this.paginator.pageSize
                : this.filteredItems.length
        );
    }

    private _data: IItemBase[];

    get data(): IItemBase[] {
        return this._data;
    }

    @Input() set data(val: IItemBase[]) {
        if (val) {
            this._data = val;
            this.listItem = { count: val.length, results: val };
        }
    }

    get filteredItems(): IItemBase[] {
        return this.listItem.results.filter(e => e.filtered === false || e.filtered === undefined);
    }

    get isMobile(): boolean {
        return window.innerWidth <= 600;
    }

    ngOnInit() {
        this.currentEvent = {
            pageSize: this.pageSize ? this.pageSize : 10,
            pageIndex: 0,
            previousPageIndex: 0,
            length: this.listItem ? this.listItem.count : 0
        };

        this.subscription = this.filterService.onFilter.subscribe(() => this.changeDetection.detectChanges());
    }

    ngAfterViewInit() {
        this.changed.emit();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    loadPage(event: PageEvent) {
        this.currentEvent = event;
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    reset() {
        this.currentEvent = {
            pageSize: 10,
            pageIndex: 0,
            length: this.data ? this.listItem.count : 0
        };
    }
}
